import * as XLSX from "xlsx";
import { SITE_ASSESSMENT_NAMES } from "../../assessments.table/table.utils";
import { findCellWithValueInRange, getMergedCellValue } from "../../../../../app/utils/process.excel.helper";

// Shared showSnackbar function reference
let showSnackbar = null;
let currency = null;

const SITE_COSTS = "Site Costs";
const TOTAL_AMOUNT_PER_SITE_COST = "Total Amount Per Site Cost";
const FORECASTED_FREQUENCY = "Forecasted Frequency";

// Main processing function
export const processSiteFeesData = (worksheet, currencyInput, showSnackbarFn) => {
    if (!worksheet) return [];

    // Initialize the shared showSnackbar function
    showSnackbar = showSnackbarFn;
    currency = currencyInput;
    // Get sheet dimensions
    const range = XLSX.utils.decode_range(worksheet["!ref"]);
    const maxRow = range.e.r;
    // const maxCol = range.e.c;

    const { typeCell, totalAmountCell, siteNamesOrForecast } = getPointerCells(worksheet, maxRow);
    if (!typeCell || !totalAmountCell || !siteNamesOrForecast) return [];

    const assessments = getAssessmentNamesAndCostsAcum(
        worksheet,
        maxRow,
        typeCell,
        totalAmountCell,
    );
    
    return assessments;
}

// Find the "Site Costs" cell, checking all cells in first few columns
const getPointerCells = (worksheet, maxRow) => {
    const typeCell = findCellWithValueInRange(
        worksheet,
        SITE_COSTS,
        0,
        maxRow,
        0,
        3, // Check columns A through D (0-3)
    );
    const totalAmountCell = findCellWithValueInRange(
        worksheet,
        TOTAL_AMOUNT_PER_SITE_COST,
        0,
        maxRow,
        0,
        3, // Check columns A through D (0-3)
    );
    const forecastedFrequencyCell = findCellWithValueInRange(
        worksheet,
        FORECASTED_FREQUENCY,
        0,
        maxRow,
        0,
        3, // Check columns A through D (0-3)
    );
    const assessmentNameCell = findAssessmentNamesInFirstColumn(worksheet, maxRow);
    const siteNamesOrForecast = !!(forecastedFrequencyCell && forecastedFrequencyCell?.col === 1 && assessmentNameCell);
    if (!typeCell || !totalAmountCell) {
        showSnackbar(
            `The '${SITE_COSTS}' row or '${TOTAL_AMOUNT_PER_SITE_COST}' row label are missing from the 'Invoiceables and Site Fees' sheet.`,
            "warning",
        );
    }
    if (!siteNamesOrForecast) {
        showSnackbar(
            `The Site Costs and/or Forecasted Frequency columns are missing from the 'Invoiceables and Site Fees' sheet. Site costs have not been imported.`,
            "warning",
        );
    }
    return { typeCell, totalAmountCell, siteNamesOrForecast };
};

const findAssessmentNamesInFirstColumn = (worksheet, maxRow) => {
    for (let row = 0; row < maxRow; row++) {
        const cellAddress = XLSX.utils.encode_cell({ r: row, c: 0 });
        const cellValue = getMergedCellValue(worksheet, cellAddress);
        if (SITE_ASSESSMENT_NAMES.includes(cellValue)) {
            return { row, col: 0 };
        }
    }
    return null; // Not found
}

// Get assessment names starting from column E (index 4)
const getAssessmentNamesAndCostsAcum = (worksheet, maxRow, assessmentNameIndex, assessmentCostIndex) => {
    const assessments = [];
    let writtenAssessments = 0;
    let voidCost = 0;

    for (let row = assessmentNameIndex?.row + 1; row < maxRow; row++) {
        const nameCellAddress = XLSX.utils.encode_cell({ r: row, c: assessmentNameIndex?.col });
        const nameCellValue = getMergedCellValue(worksheet, nameCellAddress);
        if (!nameCellValue) continue;

        const costCellAddress = XLSX.utils.encode_cell({ r: row, c: assessmentCostIndex?.col });
        const costCellValue = getMergedCellValue(worksheet, costCellAddress);
        const siteName = SITE_ASSESSMENT_NAMES.find((name) => name === nameCellValue);
        const siteCost = (costCellValue && !isNaN(costCellValue)) ? costCellValue : 0;

        if (siteName) {
            writtenAssessments++;
            voidCost = siteCost === 0 ? voidCost + 1 : voidCost;
            assessments.push({
                assessmentName: siteName,
                assessmentCost: siteCost,
                currency: currency,
            });
        }
    }

    if (writtenAssessments === voidCost) {
        showSnackbar(
            `No ${TOTAL_AMOUNT_PER_SITE_COST} was calculated on the 'Invoiceables and Site Fees' sheet. Site costs have not been imported.`,
            "warning",
        );
    }
    if (assessments.length === 0) {
        showSnackbar(
            `No valid ${SITE_COSTS} were found in Column A on the 'Invoiceables and Site Fees' sheet. Site costs have not been imported.`,
            "warning",
        );
    }
    return assessments;
};